/**
 * Latest-only CheckInOut $lookup for summary counts.
 * Uses orderItemId+time index via $sort+$limit:1 — never pulls full history.
 */
export function buildLatestCheckInOutLookup(options?: {
  as?: string;
  zoneOid?: { $oid: string };
}): Record<string, unknown> {
  const as = options?.as ?? "checksInOut";
  return {
    $lookup: {
      from: "CheckInOut",
      let: { orderItemId: "$_id" },
      pipeline: [
        {
          $match: {
            $expr: { $eq: ["$orderItemId", "$$orderItemId"] },
            ...(options?.zoneOid ? { zoneId: options.zoneOid } : {}),
          },
        },
        { $sort: { time: -1, _id: -1 } },
        { $limit: 1 },
        { $project: { type: 1, deletedAt: 1 } },
      ],
      as,
    },
  };
}

/** Status from a latest-only `checksInOut` array (index 0, not last-of-unbounded). */
export function latestCheckInOutStatusExpression() {
  return {
    $ifNull: [{ $arrayElemAt: ["$checksInOut.type", 0] }, "NOT_CHECK_IN"],
  };
}
